
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/privacy-policy/[slug]",
      function () {
        return require("private-next-pages/legal/privacy-policy/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/privacy-policy/[slug]"])
      });
    }
  